import { gql } from '@provision/graphql-client';

export const START_SIDEKICK_RUN = gql`
  mutation StartSidekickRun($input: StartSidekickRunInput!) {
    startSidekickRun(params: $input) {
      id
      partnerId
      conversationId
      userId
      status
      aiProviderResponseId
      previousResponseId
      errorMessage
      chunkSequence
      createdAt
      updatedAt
    }
  }
`;

export const GET_SIDEKICK_RUNS = gql`
  query GetSidekickRuns($params: GetSidekickRunsInput!) {
    getSidekickRuns(params: $params) {
      id
      partnerId
      conversationId
      userId
      status
      aiProviderResponseId
      previousResponseId
      errorMessage
      chunkSequence
      createdAt
      updatedAt
    }
  }
`;

export const GET_SIDEKICK_RUN_RESULT = gql`
  query GetSidekickRunResult($params: GetSidekickRunResultInput!) {
    getSidekickRunResult(params: $params) {
      runId
      status
      errorMessage
      aiProviderResponseId
      assistantMessage {
        text
        html
      }
    }
  }
`;

export const GET_SIDEKICK_SUGGESTED_QUESTIONS = gql`
  query GetSidekickSuggestedQuestions($params: GetSidekickSuggestedQuestionsInput!) {
    getSidekickSuggestedQuestions(params: $params) {
      questions
    }
  }
`;

export const GET_SIDEKICK_CHAT_SESSIONS = gql`
  query GetSidekickChatSessions($params: GetSidekickChatSessionsInput!) {
    getSidekickChatSessions(params: $params) {
      sessionRootRunId
      title
      previewText
      createdAt
      updatedAt
    }
  }
`;

export const GET_SIDEKICK_SESSION_RUNS = gql`
  query GetSidekickSessionRuns($params: GetSidekickSessionRunsInput!) {
    getSidekickSessionRuns(params: $params) {
      runId
      status
      errorMessage
      aiProviderResponseId
      previousResponseId
      createdAt
      updatedAt
      userMessage {
        text
        html
      }
      assistantMessage {
        text
        html
      }
    }
  }
`;

export const GET_CONVERSATION_LIVE_TRANSCRIPTION = gql`
  query GetConversationLiveTranscription($params: GetConversationLiveTranscriptionInput!) {
    getConversationLiveTranscription(params: $params) {
      transcriptionId
      externalTranscriptionId
      isFinished
      cursor
      segments {
        role
        timestamp
        transcriptionText
        start
        duration
      }
    }
  }
`;

export interface SidekickRun {
  id: string;
  partnerId: number;
  conversationId: string;
  userId: string;
  status: string;
  aiProviderResponseId?: string | null;
  previousResponseId?: string | null;
  errorMessage?: string | null;
  chunkSequence: number;
  createdAt: string;
  updatedAt: string;
}

export interface SidekickRunResult {
  runId: string;
  status: string;
  errorMessage?: string | null;
  aiProviderResponseId?: string | null;
  assistantMessage?: {
    text?: string | null;
    html?: string | null;
  } | null;
}

export interface StartSidekickRunVariables {
  input: {
    conversationId: string;
    partnerId: number;
    message: string;
    previousResponseId?: string | null;
  };
}

export interface GetSidekickRunResultVariables {
  params: {
    runId: string;
    partnerId: number;
  };
}

export interface SidekickSuggestedQuestions {
  questions: string[];
}

export interface GetSidekickSuggestedQuestionsVariables {
  params: {
    conversationId: string;
    partnerId: number;
    limit?: number | null;
  };
}

export interface SidekickChatSession {
  sessionRootRunId: string;
  title: string;
  previewText?: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface SidekickSessionRun {
  runId: string;
  status: string;
  errorMessage?: string | null;
  aiProviderResponseId?: string | null;
  previousResponseId?: string | null;
  createdAt: string;
  updatedAt: string;
  userMessage?: { text?: string | null; html?: string | null } | null;
  assistantMessage?: { text?: string | null; html?: string | null } | null;
}

export enum LiveTranscriptionRole {
  Agent = 'agent',
  Client = 'client',
}

export interface LiveTranscriptionSegment {
  role: LiveTranscriptionRole;
  timestamp: string;
  transcriptionText: string;
  start?: number | null;
  duration?: number | null;
}

export interface GetConversationLiveTranscriptionResponse {
  transcriptionId: string;
  externalTranscriptionId: string;
  isFinished: boolean;
  cursor?: string | null;
  segments: LiveTranscriptionSegment[];
}

export interface GetSidekickChatSessionsVariables {
  params: {
    conversationId: string;
    partnerId: number;
    limit?: number | null;
  };
}

export interface GetSidekickSessionRunsVariables {
  params: {
    sessionRootRunId: string;
    conversationId: string;
    partnerId: number;
    limit?: number | null;
  };
}

export interface GetConversationLiveTranscriptionVariables {
  params: {
    conversationId: string;
    partnerId: number;
    limit?: number;
    direction?: 'FORWARD' | 'REVERSE';
    cursor?: string | null;
  };
}
